import FilterPanelFilterGroup from 'components/Common/FilterPanel/FilterPanelFilterGroup'
import CounterInput from 'components/Common/Form/Input/CounterInput'
import type { EnabledFilters } from 'components/Search/type'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const InputGroup = styled(Group)`
  margin-top: ${rem(16)};
`

interface RoomFilterGroupProps {
  loading?: boolean
  filters: App.OfferListFilters
  enabledFilters: EnabledFilters
  onBedroomsChange: (value: number) => void
  onBedsChange: (value: number) => void
  onBathroomsChange: (value: number) => void
}

function RoomFilterGroup({
  loading,
  filters,
  enabledFilters,
  onBedroomsChange,
  onBedsChange,
  onBathroomsChange,
}: RoomFilterGroupProps) {
  const intl = useIntl()

  const roomsTitle = intl.formatMessage({
    id: 'HckhHizhmv',
    defaultMessage: 'Rooms',
    description: 'Title for the rooms filter section on the hotel or room booking page',
  })

  const bedroomsLabel = intl.formatMessage({
    id: '6Q4qMGSm10',
    defaultMessage: 'Bedrooms',
    description: 'Label for bedrooms counter input on the hotel or room booking page',
  })

  const bedsLabel = intl.formatMessage({
    id: 'fnQIS+HL6B',
    defaultMessage: 'Beds',
    description: 'Form field label for the number of beds counter input in the room configuration',
  })

  const bathroomsLabel = intl.formatMessage({
    id: 'wN1qfz60Xr',
    defaultMessage: 'Bathrooms',
    description: 'Label for bathrooms counter input on the hotel or room booking page',
  })

  const anyLabel = intl.formatMessage({
    id: '1JUG8N8aWP',
    defaultMessage: 'Any',
    description: 'Display label for a room filter counter value of zero',
  })

  const formatCounterValue = useCallback((value: number) => {
    return value === 0 ? anyLabel : `${value}+`
  }, [anyLabel])

  return (
    <FilterPanelFilterGroup
      loading={loading}
      title={roomsTitle}
    >
      <InputGroup direction="vertical" gap={12}>
        {enabledFilters.bedrooms && (
          <CounterInput
            name="bedroomsGte"
            defaultValue={filters.bedroomsGte ?? 0}
            onChange={onBedroomsChange}
            min={0}
            max={10}
            label={bedroomsLabel}
            direction="horizontal"
            tabletDirection="horizontal"
            valueFormatter={formatCounterValue}
          />
        )}
        {enabledFilters.beds && (
          <CounterInput
            name="bedsGte"
            defaultValue={filters.bedsGte ?? 0}
            onChange={onBedsChange}
            min={0}
            max={10}
            label={bedsLabel}
            direction="horizontal"
            tabletDirection="horizontal"
            valueFormatter={formatCounterValue}
          />
        )}
        {enabledFilters.bathrooms && (
          <CounterInput
            name="bathroomsGte"
            defaultValue={filters.bathroomsGte ?? 0}
            onChange={onBathroomsChange}
            min={0}
            max={10}
            label={bathroomsLabel}
            direction="horizontal"
            tabletDirection="horizontal"
            valueFormatter={formatCounterValue}
          />
        )}
      </InputGroup>
    </FilterPanelFilterGroup>
  )
}

export default RoomFilterGroup
